/**
 * TUUN Cart Utilities
 * Shopify Ajax API を使用したカート操作
 */

(function() {
  'use strict';

  // カートに商品を追加する関数
  window.tuunAddToCart = function(variantId, quantity) {
    quantity = quantity || 1;

    // ボタンの状態を管理
    const buttons = document.querySelectorAll('[data-tuun-add-to-cart]');
    buttons.forEach(btn => {
      btn.disabled = true;
      btn.dataset.originalText = btn.textContent;
      btn.textContent = '追加中...';
    });

    // Shopify Ajax API でカートに追加
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        items: [{
          id: variantId,
          quantity: quantity
        }]
      })
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('カートへの追加に失敗しました');
      }
      return response.json();
    })
    .then(data => {
      console.log('カートに追加されました:', data);

      // 成功メッセージ
      tuunShowNotification('商品をカートに追加しました', 'success');

      // カートページに遷移
      setTimeout(() => {
        window.location.href = '/cart';
      }, 800);
    })
    .catch(error => {
      console.error('エラー:', error);
      tuunShowNotification('カートへの追加に失敗しました', 'error');

      // ボタンを元に戻す
      buttons.forEach(btn => {
        btn.disabled = false;
        btn.textContent = btn.dataset.originalText || 'Buy';
      });
    });
  };

  // 通知を表示する関数
  window.tuunShowNotification = function(message, type) {
    // 既存の通知があれば削除
    const existingNotification = document.querySelector('.tuun-notification');
    if (existingNotification) {
      existingNotification.remove();
    }

    // 通知要素を作成
    const notification = document.createElement('div');
    notification.className = `tuun-notification tuun-notification--${type}`;
    notification.textContent = message;
    notification.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      background: ${type === 'success' ? '#5AC8FA' : '#FF3B30'};
      color: white;
      padding: 16px 24px;
      border-radius: 8px;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      z-index: 10000;
      animation: tuunSlideIn 0.3s ease-out;
      font-family: var(--font-body-family), sans-serif;
      font-size: 14px;
    `;

    document.body.appendChild(notification);

    // 3秒後に自動削除
    setTimeout(() => {
      notification.style.animation = 'tuunSlideOut 0.3s ease-out';
      setTimeout(() => {
        notification.remove();
      }, 300);
    }, 3000);
  };

  // カート数を更新する関数
  function updateCartCount() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const cartCountElements = document.querySelectorAll('[data-cart-count]');
        cartCountElements.forEach(el => {
          el.textContent = cart.item_count;
          if (cart.item_count > 0) {
            el.classList.add('has-items');
          }
        });
      })
      .catch(error => {
        console.error('カート数の更新に失敗:', error);
      });
  }

  // アニメーション用CSSを追加
  if (!document.querySelector('#tuun-notification-styles')) {
    const style = document.createElement('style');
    style.id = 'tuun-notification-styles';
    style.textContent = `
      @keyframes tuunSlideIn {
        from {
          transform: translateX(400px);
          opacity: 0;
        }
        to {
          transform: translateX(0);
          opacity: 1;
        }
      }
      @keyframes tuunSlideOut {
        from {
          transform: translateX(0);
          opacity: 1;
        }
        to {
          transform: translateX(400px);
          opacity: 0;
        }
      }
      .tuun-notification {
        font-weight: 500;
        letter-spacing: -0.01em;
      }
    `;
    document.head.appendChild(style);
  }

  // ページロード時にカート数を更新
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateCartCount);
  } else {
    updateCartCount();
  }

})();
